const closeControlSelector = 'button:is(.close-button, .predictive-search__close-modal-button, .seal-close-control, .account__close)';
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const recentPointerAnimations = new WeakMap();
const activeTimers = new WeakMap();
let pointerModality = false;

function getCloseControl(event) {
  return event.composedPath().find((target) => target instanceof HTMLElement && target.matches(closeControlSelector));
}

function animateCloseControl(control) {
  if (prefersReducedMotion.matches) return;
  window.clearTimeout(activeTimers.get(control));
  control.classList.remove('seal-close-is-pressing');
  void control.offsetWidth;
  control.classList.add('seal-close-is-pressing');
  activeTimers.set(control, window.setTimeout(() => {
    control.classList.remove('seal-close-is-pressing');
    activeTimers.delete(control);
  }, 220));
}

document.addEventListener('pointerdown', (event) => {
  pointerModality = true;
  if (event.button !== 0) return;
  const control = getCloseControl(event);
  if (!control) return;
  recentPointerAnimations.set(control, Date.now());
  animateCloseControl(control);
}, { capture: true, passive: true });

document.addEventListener('keydown', (event) => {
  pointerModality = false;
  getCloseControl(event)?.removeAttribute('data-seal-close-pointer-focus');
}, { capture: true });

document.addEventListener('focusin', (event) => {
  const control = getCloseControl(event);
  if (control) control.toggleAttribute('data-seal-close-pointer-focus', pointerModality);
}, { capture: true });

document.addEventListener('click', (event) => {
  const control = getCloseControl(event);
  if (!control || Date.now() - (recentPointerAnimations.get(control) || 0) < 220) return;
  animateCloseControl(control);
}, { capture: true });

// Share the actual stylesheet with Shopify's account shadow DOM, preserving
// the original button, accessible label, focus handling and close listeners.
const accountRoots = new WeakSet();
const stylesheetUrl = document.querySelector('link[href*="/seal-close-interactions.css"]')?.href;

function connectAccount(account) {
  const root = account.shadowRoot;
  if (!root || accountRoots.has(root) || !stylesheetUrl) return;
  accountRoots.add(root);

  function syncAccountControl() {
    if (!root.querySelector('[data-seal-close-styles]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = stylesheetUrl;
      link.dataset.sealCloseStyles = '';
      root.append(link);
    }
    const icon = root.querySelector('.account__close svg:not([data-seal-close-icon])');
    if (!icon) return;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 14 14');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.dataset.sealCloseIcon = '';
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M12 2L2 12M12 12L2 2');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', 'var(--icon-stroke-width, 1.5)');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    icon.replaceWith(svg);
  }

  syncAccountControl();
  new MutationObserver(syncAccountControl).observe(root, { childList: true, subtree: true });
}

customElements.whenDefined('shopify-account').then(() => {
  document.querySelectorAll('shopify-account').forEach(connectAccount);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('shopify-account')) connectAccount(node);
        node.querySelectorAll('shopify-account').forEach(connectAccount);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
});
